import { normalizeUrl } from '@univdiam/ui/lib/UrlNormalize';
import { cn } from '@univdiam/ui/lib/utils';
import React from 'react';
import {
    FaFilePdf,
    FaFileWord,
    FaFileExcel,
    FaFilePowerpoint,
    FaFileArchive,
    FaFileAlt,
    FaDownload,
    FaFileVideo,
} from 'react-icons/fa';

type MediaFile = {
    url: string;
    name: string;
    size: number;
    type: string; // e.g., 'image/jpeg', 'application/pdf'
};

const getFileIcon = (type: string) => {
    if (type.includes('pdf')) return <FaFilePdf className="text-red-500" />;
    if (type.includes('word')) return <FaFileWord className="text-blue-500" />;
    if (type.includes('excel')) return <FaFileExcel className="text-green-500" />;
    if (type.includes('powerpoint')) return <FaFilePowerpoint className="text-orange-500" />;
    if (type.includes('zip') || type.includes('rar')) return <FaFileArchive className="text-yellow-500" />;
    if (type.includes('video')) return <FaFileVideo className="text-purple-500" />;
    return <FaFileAlt className="text-gray-500" />;
};

// const handleDownload = (url: string) => {
//     const fileUrl = normalizeUrl(url);
//     const fileName = 'UnivDiam_' + (fileUrl.split('/').pop()?.split('?')[0] || 'file');

//     const link = document.createElement('a');
//     link.href = fileUrl;
//     link.download = fileName;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
// };


const handleDownload = async (url: string) => {
    try {
        const response = await fetch(url, {
            headers: {
                'Accept': 'video/mp4,video/*,*/*',
                'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36'
            }
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const blob = await response.blob()
        const contentType = response.headers.get('content-type')

        // Determine file extension from content type or URL
        let extension = 'mp4'
        if (contentType?.includes('webm')) extension = 'webm'
        if (contentType?.includes('quicktime')) extension = 'mov'
        if (contentType?.includes('x-m4v')) extension = 'm4v'

        const fileName = 'UnivDiam_' + (url.split('/').pop()?.split('?')[0] || `video.${extension}`)

        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)

    } catch (err) {
        console.error('Download failed:', err)
    }
};

const MediaRenderer: React.FC<{ file: MediaFile; className?: string }> = ({
    file,
    className,
}) => {
    const { url, type, name } = file;
    if (type.startsWith('image/')) {
        return (
            <a
                href={normalizeUrl(url)}
                target="_blank"
                rel="noopener noreferrer"
                className="relative group"
            >
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        handleDownload(url);
                    }}
                    className="absolute top-2 right-2 z-10 p-2 rounded-full bg-white/90 backdrop-blur-sm border border-gray-300 shadow-md text-gray-700 opacity-0 group-hover:opacity-100 hover:bg-white transition-all duration-200 cursor-pointer"
                >
                    <FaDownload size={12} />
                </button>
                <img
                    key={url}
                    src={normalizeUrl(url)}
                    alt={name}
                    className={cn(
                        'w-[128px] h-[128px] rounded-lg border border-[#E9EAEB] object-cover shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer',
                        className
                    )}
                />
            </a>
        );
    }

    return (
        <a
            href={normalizeUrl(url)}
            target="_blank"
            rel="noopener noreferrer"
            title={name}
            className="relative group"
        >
            <button
                onClick={(e) => {
                    e.preventDefault();
                    handleDownload(url);
                }}
                className="absolute top-2 right-2 z-10 p-2 rounded-full bg-white/90 backdrop-blur-sm border border-gray-300 shadow-md text-gray-700 opacity-0 group-hover:opacity-100 hover:bg-white  transition-all duration-200 cursor-pointer"
            >
                <FaDownload size={12} />
            </button>
            <div
                className={cn(
                    'w-[128px] h-[128px] rounded-lg border border-[#E9EAEB] flex items-center justify-center text-[36px] bg-white shadow-sm hover:shadow-md transition-shadow duration-200',
                    className
                )}
            >
                {getFileIcon(type)}
            </div>
        </a>
    );
};

export default MediaRenderer;
